export default __webpack_public_path__ + "static/media/fr.9669a030.svg";